import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=4394a028"
import script from "./BaseTag.vue?vue&type=script&lang=js"
export * from "./BaseTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTooltip: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/09062026_084924/resources/assets/marketplace/components/BaseTooltip.vue').default})
